import { motion } from 'framer-motion';

/* eslint-disable-next-line */
type AnimatedDivProps = {
  children: React.ReactNode | React.ReactNodeArray;
  className: string;
};

export function AnimatedDiv(props: AnimatedDivProps) {
  const { children, className } = props;

  return (
    <motion.div
      animate={{ opacity: 1, scale: 1 }}
      className={className}
      initial={{ opacity: 0, scale: 0.5 }}
      transition={{ duration: 0.5 }}
    >
      {children}
    </motion.div>
  );
}

export default AnimatedDiv;
